export default __webpack_public_path__ + "static/media/logo.10549c3d.png";